
const KEY_BASE = "tilannekuva:"

export const TilannekuvaCacheKeys = {
    MaptilerTilesetInstance: (id: string) => [KEY_BASE, "MaptilerTilesetInstance", id].join("-"),
    MapresourceInstance: (url: string) => [KEY_BASE, "MapresourceInstance", url].join("-"),
    TargetingSchemeInstance: (referenceName: string) => [KEY_BASE, "TargetingSchemeInstance", referenceName].join("-"),

    MapList: () => [KEY_BASE, "mapList"].join("-")

};
